import { styled } from '@mui/system';
import * as React from 'react';
import { take } from 'Utility/ramdaReplacement';
import { RenderValue } from './common/commonComponents';
import { border, dateCell, height, table, titleCell, valueCell } from './common/commonStyles';

import type { IData } from './definitions';
import type { Theme } from '@mui/material/styles';

const DataTable = styled('table')(table);

const DataRow = styled('tr')({
  height,
  verticalAlign: 'baseline',
  lineHeight: '2rem',
});

const DataCellDate = styled('td')(({ theme }: { theme?: Theme }) => ({
  ...dateCell(theme),
  padding: '0.7rem 0 0.7rem 0.6rem',
  borderTop: border(theme),
}));

const DataCellTitle = styled('td', {
  shouldForwardProp: prop => prop !== 'hasValue',
})(({ theme, hasValue }: { theme?: Theme; hasValue: boolean }) => ({
  ...titleCell(theme, true, hasValue),
  padding: hasValue ? '0.7rem 0 0.7rem 0' : '0.7rem 0.6rem 0.7rem 0',
  borderTop: border(theme),
}));

const DataCellValue = styled('td')(({ theme }: { theme?: Theme }) => ({
  ...valueCell(theme),
  padding: '0.7rem 0.6rem 0.7rem 0',
  borderTop: border(theme),
}));

const SpecificListMultipleRows = ({ data, itemsCanFitAmount, styles }: ISpecificListMultipleRows) => {
  const shownItems = take(itemsCanFitAmount, data);
  const renderValueCol = data.some(d => d.endDate ?? d.value);
  return (
    <DataTable>
      <tbody>
        {shownItems.map(d => (
          <DataRow key={d.key}>
            <DataCellDate style={styles?.date}>{d.date}</DataCellDate>
            <DataCellTitle hasValue={!!d.value} style={styles?.title}>
              {d.title}
            </DataCellTitle>
            {renderValueCol && (
              <DataCellValue>
                <RenderValue value={d.value} endDate={d.endDate} />
              </DataCellValue>
            )}
          </DataRow>
        ))}
      </tbody>
    </DataTable>
  );
};

export interface ISpecificListMultipleRows {
  type: 'specificListMultipleRows';
  data: Array<IData>;
  itemsCanFitAmount: number;
  styles?: { date?: React.CSSProperties; title?: React.CSSProperties; value?: React.CSSProperties };
}

export default SpecificListMultipleRows;
